import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { graphql, useStaticQuery } from "gatsby";

const Seo = ({ description, meta, keywords, title, pageContext }) => {
  const data = useStaticQuery(graphql`
      query DefaultSEOQuery {
          site {
              siteMetadata {
                  title
                  description
                  author
              }
          }
      }
  `);
  const metaDescription = description || data.site.siteMetadata.description;
  const { siteUrl, originalPath, availableLngs, lng, fallbackLng } = pageContext;

  return (
    <Helmet titleTemplate={`${data.site.siteMetadata.title} | %s`}>
      <html lang={lng} />
      <meta charSet="utf-8"/>
      <title>{title}</title>
      <meta name="description" content={metaDescription}/>
      <meta name="og:title" content={title}/>
      <meta name="og:description" content={metaDescription}/>
      <meta name="og:type" content="website"/>
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:creator" content={data.site.siteMetadata.author}/>
      <meta name="twitter:title" content={title}/>
      <meta name="twitter:description" content={metaDescription}/>
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(", ")}/>}
      {meta.map((value) => (
        <meta name={value.name} content={value.content}/>
      ))}

      <link rel="alternate" href={`${siteUrl}`} hreflang="x-default"/>
      {availableLngs.map(value => {
        if (value !== fallbackLng) {
          return (
            <link
              key={value}
              rel="alternate"
              href={`${siteUrl}/${value}${originalPath}`}
              hreflang={value}
            />
          );
        }

        return null;
      })}
    </Helmet>
  )
};

Seo.defaultProps = {
  meta: [],
  keywords: [],
};

Seo.propTypes = {
  description: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
};

export default Seo;
